module.exports = __webpack_public_path__ + "img/productIcon.a7a7cc1a.png";